<script context="module" lang="ts">
  import back from './svg/back.svg';
  import bullet_end from './svg/bullet-end.svg';
  import bullet_start from './svg/bullet-start.svg';
  import bullet_step from './svg/bullet-step.svg';
  import close from './svg/close.svg';
  import direction from './svg/direction.svg';
  import exit from './svg/exit.svg';
  import flip from './svg/flip.svg';
  import info from './svg/info.svg';
  import search from './svg/search.svg';

  const icons = {
    back,
    bullet_end,
    bullet_start,
    bullet_step,
    close,
    direction,
    exit,
    flip,
    info,
    search,
  } as const;

  export type IconType = keyof typeof icons
</script>

<script lang="ts">
  export let name: IconType;
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<img class="icon" src={icons[name].src} />

<style>
  .icon {
    max-width: 100%;
    max-height: 100%;
  }
</style>